import React, { useEffect, useMemo, useRef, useState } from 'react';
import styles from '../ClipCard/ClipCard.module.scss';
import { Card } from '../Card';
import CardThumbnail from '../Card/CardThumbnail';
import Col from '../GridSystem/Col';
import CardFooter from '../Card/CardFooter';
import cx from 'classnames';
import { formatSecondsToDuration, timeStampToMs } from '../../utils/TimeUtil';
import { useTrimContext } from '../../context/VideoTrimContex';
import { useTextPanelContext } from '../../context/TextPanelContext';
import { useBackgroundMusicContext } from '../../context/BackgroundMusicContext';
import { useVideoSpeedUpContext } from '../../context/VideoSpeedUpContext';
import { useLogoContext } from '../../context/LogoContext';
import { useZoomContext } from '../../context/ZoomContext';
import { START_LIST_HEIGHT_FOR_MINI } from '../../constants/editorConst';

const currentCardRatio = 4 / 3.45; // based on height

const ClipCardIntroOutro = ({ clip, clipIndex, handleSelectClip, selectedClip, outro, disabled }) => {
  const [hoverCard, setHoverCard] = useState(false);
  const [duration, setDuration] = useState('');
  const { trimmingOn } = useTrimContext();
  const { isTextPanelEditor } = useTextPanelContext();
  const { isBackgroundMusicOpened } = useBackgroundMusicContext();
  const { isVideoSpeedUpOpened } = useVideoSpeedUpContext();
  const { isLogoEditor } = useLogoContext();
  const { isZoomOpened } = useZoomContext();

  const [showMinCard, setShowMinCard] = useState(false);

  const cardRef = useRef(null);

  const cardStyles = useMemo(() => ({ width: cardRef?.current?.offsetHeight * currentCardRatio + 'px' }), [
    cardRef?.current?.offsetHeight,
  ]);

  useEffect(() => {
    setShowMinCard(cardRef?.current?.parentElement?.offsetHeight <= START_LIST_HEIGHT_FOR_MINI);
  }, [cardRef?.current?.parentElement?.offsetHeight]);

  useEffect(() => {
    if (clip?.duration) {
      setDuration(formatSecondsToDuration(clip.duration / 1000));
    } else {
      const startTime = timeStampToMs(clip?.trimStart);
      const endTime = timeStampToMs(clip?.trimEnd);
      setDuration(formatSecondsToDuration((endTime - startTime) / 1000));
    }
  }, [clip]);

  const toggleMouseEnterCard = () => {
    setHoverCard(true);
  };

  const toggleMouseLeaveCard = () => {
    setHoverCard(false);
  };

  const handleCardClip = e => {
    if (!trimmingOn && !isTextPanelEditor && !isBackgroundMusicOpened && !isVideoSpeedUpOpened && !isLogoEditor && !isZoomOpened) {
      const isTargetCard = Array.from(e.target.parentElement.classList)
        .join('')
        .includes('Card');
      if (isTargetCard) {
        !clip.processing && !disabled && handleSelectClip(clipIndex);
      }
    }
  };

  return (
    <div ref={cardRef} className={cx(styles.listCol, { [styles.lastCard]: outro, [styles.firstCard]: !outro })} style={cardStyles}>
      <Card
        className={cx(styles.clipCard, {
          [styles.activeClip]: selectedClip,
          [styles.disabled]:
            trimmingOn ||
            isTextPanelEditor ||
            isBackgroundMusicOpened ||
            isVideoSpeedUpOpened ||
            isLogoEditor ||
            isZoomOpened ||
            disabled,
          [styles.processing]: clip.processing,
        })}
        onMouseEnter={() => toggleMouseEnterCard()}
        onMouseLeave={() => toggleMouseLeaveCard()}
        onClick={handleCardClip}
        childrenClassName={styles.clipCardChildren}
      >
        <div className={cx(styles.thumbnailTitleContainer, { [styles.fullHeight]: showMinCard })}>
          {showMinCard && <div className={cx(styles.idName)}>{clip?.id}</div>}
          <CardThumbnail
            className={cx(styles.cardThumbnail, styles.cardThumbnailIntroOutro)}
            listMode={false}
            src={clip?.thumbnail}
            alt="Click for Details"
            processing={clip.processing}
          />
          {showMinCard && <div className={cx(styles.duration, styles.minCard)}>{duration}</div>}
        </div>
        {!showMinCard && (
          <CardFooter className={styles.footerCard}>
            <div className={styles.idName}>{clip?.id}</div>
            {<div className={styles.duration}>{duration}</div>}
          </CardFooter>
        )}
      </Card>
    </div>
  );
};

export default ClipCardIntroOutro;
